import './MostPopular.css'
import {Card, SectionHeader,SectionWrapper} from '../../components/index'

import MostPop from '../../Data/MostPop'

const MostPopular = () => {


const cards = MostPop.map(card => {
 return <Card key={card.id} img={card.img} title={card.title} category={card.category} rate={card.rate} downloads={card.download} />
})

  return (
        <SectionWrapper>
      <SectionHeader>most popular</SectionHeader>
        <div className='most-popular-items'>
        {cards}

          

         
        </div>
      
   </SectionWrapper>
  )
}

export default MostPopular

/*
 <Card img={popular_01} title='Fortnite' category='sandbox' rate='3.6' downloads='2.2M'/>
         <Card img={popular_02} title='pupG' category='stream-X' rate='4.3' downloads='1.2M'/>
         <Card img={popular_03} title='Dota2' category='Legandary' rate='3.1' downloads='3.5M'/>
         <Card img={popular_04} title='CS-Go' category='Battle S' rate='2.7' downloads='2.2M'/>

         <Card img={popular_05} title='Fortnite' category='sandbox' rate='3.6' downloads='2.2M'/>
         <Card img={popular_06} title='pupG' category='stream-X' rate='4.3' downloads='1.2M'/>
         <Card img={popular_07} title='Dota2' category='Legandary' rate='3.1' downloads='3.5M'/>
         <Card img={popular_08} title='CS-Go' category='Battle S' rate='2.7' downloads='2.2M'/>
         */